import React from 'react';
import { autobind } from 'core-decorators';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import CopiarLayout from '../widget-custom/componentes/copiar-layout';
import history from '../../history';
import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import { capitalizeFirstLetter } from 'src/utils/string';
import Content from 'src/componentes/pages/content';
import LucideIcon from 'src/componentes/lucide-icon';
import ContentManager from 'src/componentes/content-manager';
import { setPresentation } from 'src/actions/presentation';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';
import { DownloadFile, ParseError } from 'src/services/downloadFileUrl';
import Alert from 'src/componentes/message-box/alert';
import SearchSchema from './search-schema';
import Search from './search';
import { Schema } from 'src/utils/form';
import qs from 'query-string';
import CriticalConfirm from 'src/componentes/message-box/critical-confirm';
import Badge from 'src/componentes/Badge';

@autobind
class Apresentacao extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      atualizarTela: false,
      idApresentacao: null,
      idFiltroSalvo: 0,
      ehFavorito: false,
      tipoFiltro: null,
    };
  }

  getFiltroFavorito = (id, ehFavorito, tipoFiltro) => {
    this.setState({
      idFiltroSalvo: id,
      ehFavorito: ehFavorito,
      tipoFiltro: tipoFiltro,
    });
  };

  handleNomeClick(item) {
    history.push({
      pathname: '/acompanhar/apresentacao',
      search: `?id=${item.id}&ehGestaoAVista=${false}`,
    });
  }

  renderNome(item) {
    return (
      <a
        tabIndex="-1"
        className="d-flex align-items-center"
        onClick={this.handleNomeClick.bind(this, item)}
      >
        <LucideIcon icon="Play" className="mr-1" /> {item.nome}
      </a>
    );
  }

  handleDeleteClick(item) {
    ContentManager.addContent(
      <CriticalConfirm
        title={this.props.intl.formatMessage({ id: 'excluir' })}
        message={this.props.intl.formatMessage({
          id: 'label.desejaMesmoExcluirEsseRegistro',
        })}
        validationEndpoint="/Apresentacao/ValidarRestricoes"
        validationData={{ id: item.id }}
        handleConfirm={() => this.handleDeleteConfirm(item)}
        handleCancel={() => {}}
      />
    );
  }

  handleDeleteConfirm(item) {
    http
      .post('/Apresentacao/Remove', { id: item.id })
      .then(() => {
        this.atualizarTela();
        ContentManager.addContent(
          <Alert
            title={this.props.intl.formatMessage({ id: 'sucesso' })}
            message={this.props.intl.formatMessage({
              id: 'label.registroExcluidoComSucesso',
            })}
          />
        );
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  async atualizarTela() {
    await this.setState({
      atualizarTela: !this.state.atualizarTela,
    });
  }

  handleExport(apresentacao) {
    apresentacao && this.props.setPresentation(apresentacao.id);
    ContentManager.addContent(
      <Alert
        message={this.props.intl.formatMessage({ id: 'downloadEmBreve' })}
      />
    );
    http
      .post(
        `/Apresentacao/GerarRelatorio`,
        {
          id: apresentacao.id,
          orientacaoId: 1,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .then((response) => {
        DownloadFile(response);
      })
      .catch((error) => {
        errorHandler(ParseError(error));
      });
  }

  renderStatus(item) {
    if (!item.status) return;

    return (
      <Badge
        pill
        style={{ color: item.status.cor, background: item.status.corFundo }}
      >
        {item.status.descricao}
      </Badge>
    );
  }

  handleAtivarInativarClick(item) {
    http
      .post(`/Apresentacao/AtivarInativarApresentacao`, {
        idApresentacao: item.id,
        ativar: item.status.id === 0,
      })
      .then(() => {
        this.atualizarTela();
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  handleCopiarLayoutClick(item) {
    this.setState({ idApresentacao: item.id });
    const schema = Schema.object({
      descricao: Schema.string()
        .label(<FormattedMessage id="descricao" />)
        .required(),
      area: Schema.string().label().required(),
    });
    ContentManager.addContent(
      <CopiarLayout
        item={item}
        schema={schema}
        salvarLayout={this.handleSalvarCopiaLayoutClick}
      />
    );
  }

  handleSalvarCopiaLayoutClick(model) {
    http
      .post(`/Apresentacao/SalvarCopiaLayout`, {
        id: this.state.idApresentacao,
        nome: model.descricao,
        idArea: model.area && model.area.id,
      })
      .then(() => {
        this.atualizarTela();
        ContentManager.addContent(
          <Alert
            title={<FormattedMessage id="sucesso" />}
            message={<FormattedMessage id="label.registroCopiadoComSucesso" />}
          />
        );
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  render() {
    let { resources, intl, showModal } = this.props;

    let createChildItems = [
      {
        label: <FormattedMessage id="label.apresentar" />,
        icon: 'Play',
        visible: () => true,
        onClick: this.handleNomeClick,
      },
      {
        label: <FormattedMessage id="exportar" />,
        icon: 'FileChartColumn',
        visible: () => true,
        onClick: this.handleExport,
        id: 'exportar',
      },
      {
        label: <FormattedMessage id="label.ativar" />,
        icon: 'CheckCircle',
        visible: (item) => item && item.status && item.status.id === 0,
        onClick: this.handleAtivarInativarClick,
      },
      {
        label: <FormattedMessage id="label.inativar" />,
        icon: 'XCircle',
        visible: (item) => item && item.status && item.status.id === 1,
        onClick: this.handleAtivarInativarClick,
      },
      {
        label: <FormattedMessage id="label.copiarLayout" />,
        icon: 'Copy',
        visible: () => true,
        onClick: this.handleCopiarLayoutClick,
      },
    ];

    const responsaveis =
      location && qs.parse(location.search).responsaveis
        ? JSON.parse(decodeURIComponent(qs.parse(location.search).responsaveis))
        : location && qs.parse(location.search).responsavelId
        ? [
            {
              id: qs.parse(location.search).responsavelId,
              descricao: qs.parse(location.search).responsavelNome,
              nome: qs.parse(location.search).responsavelNome,
            },
          ]
        : null;

    const areaId =
      location && qs.parse(location.search).areaId
        ? qs.parse(location.search).areaId
        : null;

    const areaNome =
      location && qs.parse(location.search).areaNome
        ? qs.parse(location.search).areaNome
        : null;

    const areasSubordinadas =
      window.location && qs.parse(window.location.search).areasSubordinadas
        ? qs.parse(window.location.search).areasSubordinadas
        : null;

    let possuiParametrosUrl =
      (responsaveis && responsaveis.length > 0) || areaId || areaNome;

    return (
      <Content
        titulo={<FormattedMessage id="apresentacoes" />}
        iconFavorite={true}
        filtroFavorito={{
          id: this.state.idFiltroSalvo,
          ehFavorito: this.state.ehFavorito,
          tipoFiltro: this.state.tipoFiltro,
        }}
      >
        <List
          url="/Apresentacao"
          createChildItems={createChildItems}
          editMode="page"
          urlEdit="/gerenciar/apresentacao/edit"
          showSearch
          showFilter
          searchSchema={SearchSchema}
          searchComponent={<Search />}
          sort="nome"
          tag={3005}
          pageSize={20}
          filtroId={58}
          onDeleting={this.handleDeleteClick}
          saved={this.state.atualizarTela}
          stickyHeader={!showModal}
          getFiltroFavorito={this.getFiltroFavorito}
          selectedFilter={
            possuiParametrosUrl && {
              valor: {
                ...(responsaveis && { responsaveis: responsaveis }),
                ...(areaId && {
                  area: [
                    {
                      id: areaId,
                      nome: areaNome,
                    },
                  ],
                }),
                ...(areasSubordinadas && { areasSubordinadas: true }),
              },
            }
          }
          openLastFilter={!possuiParametrosUrl}
          {...this.props}
          filterDrawer={!showModal}
        >
          <ListColumn
            headerText={intl.formatMessage({ id: 'nome' })}
            valueFunction={this.renderNome}
            valueField="nome"
            sortField="nome"
            required
            default
          />
          <ListColumn
            headerText={capitalizeFirstLetter(resources.responsavel)}
            valueField="responsavel"
            sortField="Responsavel.Nome"
            default
          />
          <ListColumn
            headerText={intl.formatMessage({ id: 'status' })}
            valueField="status"
            valueFunction={this.renderStatus}
            sortField="status"
          />
          <ListColumn
            headerText={capitalizeFirstLetter(resources.area)}
            valueField="area"
            sortField="area"
          />
        </List>
      </Content>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default injectIntl(
  connect(mapStateToProps, { setPresentation })(Apresentacao)
);
